<ng-template #tplOriginContent><ng-content></ng-content></ng-template> <!-- Compatible: the <ng-content> can appear only once -->

<div>
  <div *ngIf="dwMask"
    class="ant-modal-mask"
    [ngClass]="maskAnimationClassMap"
    [class.ant-modal-mask-hidden]="hidden"
    [ngStyle]="dwMaskStyle"
    [style.zIndex]="dwZIndex"
  ></div>
  <div
    (click)="onClickMask($event)"
    class="ant-modal-wrap {{ dwWrapClassName }}"
    [style.zIndex]="dwZIndex"
    [style.display]="hidden ? 'none' : ''"
    tabindex="-1"
    role="dialog"
  >
    <div #modalContainer
      class="ant-modal {{ dwClassName }}"
      [ngClass]="modalAnimationClassMap"
      [ngStyle]="dwStyle"
      [style.width]="dwWidth | toCssUnit"
      [style.transform-origin]="transformOrigin"
      role="document"
    >
      <div class="ant-modal-content">
        <button *ngIf="dwClosable" (click)="onClickCloseBtn()" class="ant-modal-close" aria-label="Close">
          <span class="ant-modal-close-x"></span>
        </button>
        <ng-container [ngSwitch]="true">
          <ng-container *ngSwitchCase="isModalType('default')" [ngTemplateOutlet]="tplContentDefault"></ng-container>
          <ng-container *ngSwitchCase="isModalType('confirm')" [ngTemplateOutlet]="tplContentConfirm"></ng-container>
        </ng-container>
      </div>
    </div>
    <div tabindex="0" style="width: 0px; height: 0px; overflow: hidden;">sentinel</div>
  </div>
</div>

<!-- [Predefined] Default Modal Content -->
<ng-template #tplContentDefault>
  <div *ngIf="dwTitle" class="ant-modal-header">
    <div class="ant-modal-title">
      <ng-container [ngSwitch]="true">
        <ng-container *ngSwitchCase="isTemplateRef(dwTitle)" [ngTemplateOutlet]="dwTitle"></ng-container>
        <ng-container *ngSwitchCase="isNonEmptyString(dwTitle)"><div [innerHTML]="dwTitle"></div></ng-container>
      </ng-container>
    </div>
  </div>
  <div class="ant-modal-body" [ngStyle]="dwBodyStyle">
    <ng-container #bodyContainer>
      <ng-container *ngIf="!isComponent(dwContent)" [ngSwitch]="true">
        <ng-container *ngSwitchCase="isTemplateRef(dwContent)" [ngTemplateOutlet]="dwContent"></ng-container>
        <ng-container *ngSwitchCase="isNonEmptyString(dwContent)"><div [innerHTML]="dwContent"></div></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="tplOriginContent"></ng-container>
      </ng-container>
    </ng-container>
  </div>
  <div *ngIf="dwFooter !== null" class="ant-modal-footer">
    <ng-container [ngSwitch]="true">
      <ng-container *ngSwitchCase="isTemplateRef(dwFooter)" [ngTemplateOutlet]="dwFooter"></ng-container>
      <ng-container *ngSwitchCase="isNonEmptyString(dwFooter)"><div [innerHTML]="dwFooter"></div></ng-container>
      <ng-container *ngSwitchCase="isModalButtons(dwFooter)">
        <button *ngFor="let button of dwFooter" dw-button
          (click)="onButtonClick(button)"
          [hidden]="!getButtonCallableProp(button, 'show')"
          [dwLoading]="getButtonCallableProp(button, 'loading')"
          [disabled]="getButtonCallableProp(button, 'disabled')"
          [dwType]="button.type"
          [dwShape]="button.shape"
          [dwSize]="button.size"
          [dwGhost]="button.ghost"
        >{{ button.label }}</button>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <button *ngIf="dwCancelText!==null" dw-button (click)="onClickOkCancel('cancel')" [dwLoading]="dwCancelLoading">
          {{ cancelText }}
        </button>
        <button *ngIf="dwOkText!==null" dw-button [dwType]="dwOkType" (click)="onClickOkCancel('ok')" [dwLoading]="dwOkLoading">
          {{ okText }}
        </button>
      </ng-container>
    </ng-container>
  </div>
</ng-template>
<!-- /[Predefined] Default Modal Content -->

<!-- [Predefined] Confirm Modal Content -->
<ng-template #tplContentConfirm>
  <div class="ant-modal-body" [ngStyle]="dwBodyStyle">
    <div class="ant-confirm-body-wrapper">
      <div class="ant-confirm-body">
        <i class="anticon anticon-{{ dwIconType }}"></i>
        <span class="ant-confirm-title">
          <ng-container [ngSwitch]="true">
            <ng-container *ngSwitchCase="isTemplateRef(dwTitle)" [ngTemplateOutlet]="dwTitle"></ng-container>
            <ng-container *ngSwitchCase="isNonEmptyString(dwTitle)"><span [innerHTML]="dwTitle"></span></ng-container>
          </ng-container>
        </span>
        <div class="ant-confirm-content">
          <ng-container #bodyContainer>
            <ng-container *ngIf="!isComponent(dwContent)" [ngSwitch]="true">
              <ng-container *ngSwitchCase="isTemplateRef(dwContent)" [ngTemplateOutlet]="dwContent"></ng-container>
              <ng-container *ngSwitchCase="isNonEmptyString(dwContent)"><div [innerHTML]="dwContent"></div></ng-container>
              <ng-container *ngSwitchDefault [ngTemplateOutlet]="tplOriginContent"></ng-container>
            </ng-container>
          </ng-container>
        </div>
      </div>
      <div class="ant-confirm-btns">
        <button dw-button *ngIf="dwCancelText!==null" (click)="onClickOkCancel('cancel')" [dwLoading]="dwCancelLoading">
          {{ cancelText }}
        </button>
        <button *ngIf="dwOkText!==null" #autoFocusButtonOk dw-button [dwType]="dwOkType" (click)="onClickOkCancel('ok')" [dwLoading]="dwOkLoading">
          {{ okText }}
        </button>
      </div>
    </div> <!-- /.ant-confirm-body-wrapper -->
  </div>
</ng-template>
<!-- /[Predefined] Confirm Modal Content -->
